import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

const STYLES: Record<Variant, string> = {
  primary: 'bg-ink text-white hover:bg-ink-strong',
  secondary: 'bg-surface text-ink border border-line hover:bg-surface-alt',
  ghost: 'text-ink-soft hover:bg-surface-sunken',
};

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  /** House rule: a control the user can see but not use renders disabled with this tooltip. */
  lockedReason?: string;
}

export function Button({ variant = 'primary', lockedReason, disabled, className = '', title, ...rest }: Props) {
  return (
    <button
      {...rest}
      disabled={disabled || !!lockedReason}
      title={lockedReason ?? title}
      className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${STYLES[variant]} ${className}`}
    />
  );
}
